import React from "react";
import InvoiceEditor from "@/pages/sales/InvoiceEditor";
export default function SaleReturns() { return <InvoiceEditor kind="sale_return" />; }
